import React, {Component} from 'react';
import {gpn} from "../GPN"
import Back from "../sections/Back";
import req from "../req";
import config from "../config";
import Toggle from "../sections/MUI/Toggle";
import InfiniteScroll from "react-infinite-scroller";
import jMoment from "jalali-moment";

class Gateway extends Component {

    state = {
        tab: "تراکنش ها",

        money: 0,

        transactions: [],
        pageTransactions: 1,
        hasNextTransactions: true,

        withdraws: [],
        pageWithdraws: 1,
        hasNextWithdraws: true
    };

    componentDidMount() {
        this.getMoney();
    }

    getMoney() {
        req.get(`/gateway/money`)
            .then(r => {
                this.setState({money: r.money});
            });
    }

    getTransactions(page = 1) {

        req.get(`/gateway/transactions`)
            .then(r => {
                const {transactions, total_page} = r;
                this.setState({
                    hasNextTransactions: total_page > page,
                    transactions: page === 1 ? transactions : [...this.state.transactions, ...transactions],
                    pageTransactions: page + 1
                });
            });
    }

    getWithdraws(page = 1) {

        req.get(`/gateway/withdraws?page=${page}`)
            .then(r => {
                const {data, total_page} = r;
                this.setState({
                    hasNextWithdraws: total_page > page,
                    withdraws: page === 1 ? data : [...this.state.withdraws, ...data],
                    pageWithdraws: page + 1
                });
            });
    }

    render() {
        let {
            tab,
            money,
            transactions, pageTransactions, hasNextTransactions,
            withdraws, pageWithdraws, hasNextWithdraws
        } = this.state;
        return (
            <div className="gateway">
                <Back {...this.props}/>
                <br/>
                <h1><span>موجودی:</span><span>{config.priceFormatter(money)}</span></h1>
                <br/>
                <Toggle
                    value={tab}
                    name="tab"
                    onChange={(name, value) => {
                        this.setState({[name]: value});
                        if (value === "تراکنش ها") {
                            this.getTransactions(1);
                        } else {
                            this.getWithdraws(1);
                        }
                    }}
                    t1={{title: "تراکنش ها"}}
                    t2={{title: "تسویه حساب ها"}}/>
                <br/>
                <div className="list">
                    {
                        tab === "تراکنش ها" ?
                            <div className="transactions">
                                <InfiniteScroll
                                    pageStart={1}
                                    loadMore={() => this.getTransactions(pageTransactions)}
                                    hasMore={hasNextTransactions}
                                    loader={<div className="loader" key={0}>دریافت ...</div>}>
                                    {
                                        transactions ? transactions?.map((t, i) =>
                                                <article key={"transaction" + i}>
                                                    <p className="transaction-id">
                                                        <span>کد تراکنش:</span><span>{t.transaction_id}</span></p>
                                                    <p className="amount">
                                                        <span>مبلغ:</span><span>{config.priceFormatter(t.amount)}</span></p>
                                                    <p className="wage">
                                                        <span>کارمزد:</span><span>{config.priceFormatter(t.wage)}</span></p>
                                                    <p className="created-at">
                                                        <span>ثبت شده در:</span><span>{jMoment(t.created_at).format("jYYYY/jMM/jDD HH:mm:ss")}</span>
                                                    </p>
                                                </article>)
                                            : null
                                    }
                                </InfiniteScroll>
                            </div>
                            :
                            <div className="withdraws">
                                <InfiniteScroll
                                    pageStart={1}
                                    loadMore={() => this.getWithdraws(pageWithdraws)}
                                    hasMore={hasNextWithdraws}
                                    loader={<div className="loader" key={0}>دریافت ...</div>}>
                                    {
                                        withdraws ? withdraws?.map((w, i) =>
                                                <article key={"withdraw" + i}>
                                                    <p className="id"><span>شناسه:</span><span>{w.id}</span></p>
                                                    <p className="tracking-number">
                                                        <span>کد پیگیری:</span><span>{w.tracking_number}</span></p>
                                                    <p className="amount">
                                                        <span>مبلغ:</span><span>{config.priceFormatter(w.amount)}</span></p>
                                                    <p className="status">
                                                        <span>وضعیت:</span><span>{w.status === "0" ? "در انتظار پرداخت" : w.status === "1" ? "پرداخت شده" : "لغو شده"}</span>
                                                    </p>
                                                    <p className="bank-name"><span>بانک:</span><span>{w.bank_name}</span>
                                                    </p>
                                                    <p className="holder-name">
                                                        <span>دارنده حساب:</span><span>{w.holder_name}</span></p>
                                                    <p className="iban"><span>شبا:</span><span>{w.iban}</span></p>
                                                    <p className="created-at">
                                                        <span>ثبت شده در:</span><span>{jMoment(w.created_at).format("jYYYY/jMM/jDD HH:mm:ss")}</span>
                                                    </p>
                                                    <p className="updated-at">
                                                        <span>آپدیت شده در:</span><span>{jMoment(w.updated_at).format("jYYYY/jMM/jDD HH:mm:ss")}</span>
                                                    </p>
                                                </article>)
                                            : null
                                    }
                                </InfiniteScroll>
                            </div>
                    }
                </div>
            </div>
        );
    }
}

export default gpn(Gateway);